var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_43620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0.25C14.5131 0.25 15.75 1.48693 15.75 3V13C15.75 14.5131 14.5131 15.75 13 15.75H3C1.48693 15.75 0.25 14.5131 0.25 13V3C0.25 1.48693 1.48693 0.25 3 0.25H13Z",
    fill: "url(#paint0_linear_295_43620)",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.425C14.25 12.575 13.325 13.5 12.175 13.5H3.825C2.675 13.5 1.75 12.575 1.75 11.425V3.075C1.75 1.925 2.675 1 3.825 1H12.15C13.3 1 14.225 1.925 14.225 3.075V11.425H14.25Z",
    fill: "url(#paint1_linear_295_43620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91602 4.84891C6.66515 4.84891 7.2447 5.14553 7.69629 5.50906C8.00875 5.76065 8.29081 6.07163 8.52832 6.34109V6.34207L8.75391 6.59793C9.10909 6.99762 9.32867 7.26315 9.57715 7.46317C9.78692 7.63192 9.94538 7.6907 10.127 7.6907C10.6664 7.69053 10.8298 7.35412 10.8301 7.25027C10.8301 6.70888 11.2692 6.27003 11.8105 6.26981C12.3521 6.26981 12.791 6.70874 12.791 7.25027C12.7909 8.72961 11.4314 9.65145 10.127 9.65164C9.37803 9.65164 8.79842 9.35504 8.34668 8.99149C7.93355 8.65895 7.56636 8.21371 7.28906 7.90164C7.02232 7.6017 6.83251 7.37714 6.64941 7.19949L6.46582 7.03641C6.25621 6.86774 6.0977 6.80984 5.91602 6.80984C5.37611 6.81002 5.21289 7.14673 5.21289 7.25027C5.21275 7.79155 4.77368 8.23052 4.23242 8.23074C3.69098 8.23074 3.25209 7.79169 3.25195 7.25027C3.25195 5.77079 4.61144 4.8491 5.91602 4.84891Z",
    fill: "#FBFBFB",
    stroke: "#39379F",
    strokeWidth: 0.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_295_43620",
    x1: 2.5,
    y1: 16,
    x2: 15,
    y2: -1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6461FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_295_43620",
    x1: 7,
    y1: 7.5,
    x2: 15,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B58FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5551FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_43620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeBasic);
export default __webpack_public_path__ + "static/media/badge-basic.bd4f4042a14291dce91458aa70f8ea9b.svg";
export { ForwardRef as ReactComponent };